export default "__VITE_ASSET__79838c5c__"